<template>
  <div>
    <!--begin::Symbol-->
    <div v-if="isLoading" class="w-100">
      <bf-icon name="loading" :spin="true"/>
    </div>
    <bf-row
      v-else
      type="flex"
      :gutter="0"
      :class="className"
      v-for="item in data"
      :key="item?.title"
    >
      <div
        class="d-flex symbol-label symbol-85"
      >
        <img :alt="`icon ${item?.title}`" :src="`${item?.image}`" />
      </div>
      <div :class="`symbol-content text-${color}`">
        <div>
          <span
            class="d-block text-m text-bold mb-xs"
            :class="`text-${color}`"
            >{{ item?.title }}</span
          >
        </div>
        <div>
          <p v-html="item?.message" />
        </div>
      </div>
      <!-- /text-content -->
    </bf-row>
    <!--end::Symbol-->
  </div>
</template>

<script>
import { IMG } from '@/config/urls';

export default {
  name: 'ListSymbol',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
    },
    color: {
      type: String,
      default: 'black',
    },
    className: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      banners: [],
      isLoadingBanners: true,
      IMG,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/_variables';
$iconWidth: 85px;

.symbol-label {
  flex: $iconWidth;
}
.symbol-85 {
  img {
    width: $iconWidth;
    height: $iconWidth;
  }
}
.symbol-content {
  flex: calc(100% - $iconWidth - $gutter);
}
</style>
